import theme from '@styles/theme';
export default {
  designersSection: {
    background: theme.rawColors.lightGrey700,
    minHeight: ['138.666667vw', '138.666667vw', 'auto'],
    height: ['auto', 'auto', '73.3072917vw', '73.3072917vw', '36.1111111vw', '27.0833333vw'],
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'visible'
  },
  designerNameText: {
    position: 'absolute',
    width: [20, 20, 20, 20, 24],
    height: [20, 20, 20, 20, 24],
    top: ['17.0666667vw', '17.0666667vw', '10.4166667vw', '10.4166667vw', '6.11111111vw', '6.04166667vw'],
    right: ['5px', '5px', '9px', '9px', '9px', 24],
    transform: 'rotate(90deg)',
    'h4.headings.heading__four': {
      fontSize: [20, 20, 20, 20, 20, 24]
    }
  },
  designerContent: (isTeam: boolean, fullContent: boolean) => ({
    position: isTeam ? 'static' : 'absolute',
    top: isTeam ? 0 : ['17.0666667vw', '17.0666667vw', '10.4166667vw', '10.4166667vw', '6.11111111vw', '5.72916667vw'],
    left: isTeam ? 0 : ['10.6666667vw', '10.6666667vw', '8.33333333vw', '8.33333333vw', '10.7638889vw', '10.15625vw'],
    bottom: 0,
    right: 0,
    padding: fullContent ? [0, 0, '10.416667vw 8.33333333vw', '10.416667vw 8.33333333vw', 0] : ['0 17.0666667vw 0 0', 0, 0, 0, '0 1.40625vw 0 0'],
    maxWidth: ['calc(100vw - 10.6666667vw)', 'calc(100vw - 10.6666667vw)', 'calc(100vw - 8.33333333vw)', 'calc(100vw - 8.33333333vw)', '466px'],
    width: ['100%', '100%', '100%', '100%', '24.2708333vw'],
    // Ensure focus outline is not clipped - WCAG 2.4.7 Focus Visible
    overflow: 'visible'
  }),
  designerDescription: (fullContent: boolean, isSingle: boolean) => ({
    marginBottom: 24,
    pr: ['calc(10.6666667vw - 24px)', 'calc(10.6666667vw + 48px)', 'calc(10.4166667vw + 48px)', 'calc(10.4166667vw + 48px)', 0],
    overflow: isSingle ? 'hidden' : 'visible',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: fullContent ? [isSingle ? '7' : '12', isSingle ? '7' : '12', '15', '14', '5', '7', '8', '16'] : [isSingle ? '"4", "4", "10", "10", "8", "7", "10", "16"' : 'unset'],
    textOverflow: 'ellipsis',
    p: {
      marginBottom: '4px'
    }
  }),
  singleDesignerContainer: (active: boolean, isTeam: boolean) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.rawColors.lightGrey700,
    // Ensure focus outline is not clipped - WCAG 2.4.7 Focus Visible
    overflow: 'visible',
    img: {
      transition: '0.3s',
      position: 'absolute',
      height: '100%',
      width: '100%'
    },
    p: isTeam ? ['17.0666667vw 17.0666667vw 10.4166667vw 10.6666667vw', '17.0666667vw 17.0666667vw 10.4166667vw 10.6666667vw', 0, 0, 0] : 0,
    opacity: active ? 1 : 0,
    display: isTeam ? ['block', 'block', 'flex', 'flex', 'block'] : 'block',
    transform: `translateX(${active ? 0 : '100%'})`,
    transition: active ? `transform .3s linear, opacity ${theme.transitions.time.long} .4s ${theme.transitions.animation.atomCurve}` : `transform 0s ${theme.transitions.time.long} linear, opacity  ${theme.transitions.time.long} ${theme.transitions.animation.atomCurve}`,
    '& > div': {
      width: isTeam ? ['100%', '100%', '45.8333333vw', '45.8333333vw', '24.2708333vw'] : ['100%', '100%', '100%', '100%', '24.2708333vw']
    },
    '& > div:nth-of-type(1)': {
      width: isTeam ? ['100%', '100%', 'calc(100% - 45.8333333vw)', 'calc(100% - 45.8333333vw)', '24.2708333vw'] : ['100%', '100%', '100%', '100%', '24.2708333vw']
    }
  }),
  teamDesignerContainer: {
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    justifyContent: ['space-between', 'space-between', 'space-between', 'space-between'],
    position: ['relative', 'relative', 'absolute'],
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    overflow: 'hidden',
    p: ['17.0666667vw 0 17.0666667vw  10.6666667vw', '17.0666667vw 0 17.0666667vw  10.6666667vw', '10.4166667vw 10.4166667vw 10.4166667vw 8.33333333vw', '10.4166667vw 10.4166667vw 10.4166667vw 8.33333333vw', '6.11111111vw 10.7638889vw', '5.72916667vw 10.15625vw']
  },
  teamDesignersBlockScroll: {
    display: ['flex'],
    justifyContent: ['flex-start', 'flex-start', 'space-between', 'space-between', 'space-between'],
    width: ['max-content', 'max-content', '100%', '100%', '100%']
  },
  teamDesignersBlock: {
    width: ['100%', '100%', '100%', '100%', '55.4166667vw'],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: ['flex-start', 'flex-start', 'flex-start', 'flex-start', 'center', 'flex-start'],
    overflowX: ['scroll', 'auto', 'auto', 'auto', 'visible'],
    overflowY: 'hidden !important'
  },
  designerThumbnail: (designersCount: number) => ({
    position: 'relative',
    width: ['33.3333333vw', '33.3333333vw', `calc(100%/${designersCount} - 0.26041667vw)`, `calc(100%/${designersCount} - 0.26041667vw)`, `calc(100%/${designersCount} - 0.625vw)`],
    height: ['49.6vw', '49.6vw', '24.21875vw', '24.21875vw', '15vw'],
    cursor: 'pointer',
    mr: [16, 16, 0, 0, 0],
    border: 'none'
  }),
  designerTabletThubnail: {
    position: 'relative',
    width: '50%',
    height: '100%;'
  },
  showDesignerIcon: {
    position: 'absolute',
    bottom: '8px',
    right: '8px'
  },
  closeButton: {
    position: 'absolute',
    top: [16, 16, 16, 16, '6.04166667vw'],
    right: [16, 16, 16, 16, '10.15625vw'],
    svg: {
      width: [24, 24, 24, 24, 40]
    }
  },
  designerContact: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    // Ensure focus outline is not clipped - WCAG 2.4.7 Focus Visible
    padding: '4px',
    margin: '-4px',
    a: {
      textDecoration: 'underline',
      letterSpacing: theme.letterSpacings.caps,
      pr: '4px',
      height: 36,
      display: 'flex',
      alignItems: 'center',
      lineHeight: '140%',
      // Ensure focus outline is fully visible
      position: 'relative',
      '&:focus-visible': {
        outline: `2px solid ${theme.rawColors.blue500}`,
        outlineOffset: '2px',
        zIndex: 1
      }
    }
  }
};